<template>
  <div ref="periodSwitch" class="period-switch">
    <div
      v-for="option in options"
      :key="option.id"
      class="period-switch__item"
      :class="{
        'is-active':
          (selectedPeriod ? selectedPeriod : selected) === option.value
      }"
      :ref="`periodSwitchItem_${option.value}`"
      @click="onClickHandler(option, $event)"
    >
      {{ option.text }}
    </div>
  </div>
</template>

<script>
import cuid from "cuid";
export default {
  name: "PaymentsPeriodSwitch",
  props: {
    value: {
      type: String,
      default: "month"
    }
  },
  data() {
    return {
      selected: null,
      options: [
        {
          id: cuid(),
          value: "month",
          text: this.$t("message.payments.payMonthly")
        },
        {
          id: cuid(),
          value: "year",
          text: this.$t("message.payments.payAnnually")
        }
      ]
    };
  },
  computed: {
    selectedPeriod() {
      return this.$store.state.payments.selectedPeriod;
    }
  },
  created() {
    if (!this.selectedPeriod) {
      this.selected = this.value;
      this.$store.dispatch("payments/setSelectedPeriod", this.value);
    } else {
      this.selected = this.selectedPeriod;
    }
  },
  mounted() {
    this.setItemDimensions();
  },
  methods: {
    setItemDimensions(target) {
      const itemWidth = this.getItemWidth(target);
      const offsetLeft = this.getOffsetLeft(target);

      this.$refs.periodSwitch.style.setProperty("--width", `${itemWidth}px`);
      this.$refs.periodSwitch.style.setProperty("--offset", `${offsetLeft}px`);
    },
    getItemWidth(target) {
      if (target) {
        return target.offsetWidth;
      } else {
        const preselectedOptionId = this.options.find(
          option => option.value === this.selected
        ).value;
        return this.$refs[`periodSwitchItem_${preselectedOptionId}`][0]
          .offsetWidth;
      }
    },
    getOffsetLeft(target) {
      if (target) {
        return target.offsetLeft;
      } else {
        const preselectedOptionId = this.options.find(
          option => option.value === this.selected
        ).value;
        return this.$refs[`periodSwitchItem_${preselectedOptionId}`][0]
          .offsetLeft;
      }
    },
    onClickHandler(option, e) {
      this.setItemDimensions(e.target);
      this.selected = option.value;
      this.$store.dispatch("payments/setSelectedPeriod", option.value);
    }
  }
};
</script>

<style lang="scss" scoped>
.period-switch {
  --offset: 0px;
  --transition-duration: 0.2s;
  display: flex;
  align-items: center;
  border: 2px solid white;
  border-radius: 40px;
  overflow: hidden;
  padding: $spacing * 0.25 0;
  position: relative;
  height: 32px;
  box-shadow: 0px 0px 0px 1px $gray-300;
  @include font-size(14px);

  &:after {
    position: absolute;
    content: "";
    height: 100%;
    width: var(--width);
    transform: translateX(var(--offset));
    background-color: $primary;
    transition-property: width, transform;
    transition-duration: var(--transition-duration);
    border-radius: 40px;
  }

  &__item {
    padding: 0 12px;
    cursor: pointer;
    position: relative;
    z-index: 1;
    @include font-size(12px);

    &.is-active {
      color: white;
      transition: color var(--transition-duration);
    }
  }
}
</style>
